import {createContext, useContext} from 'react'
import {AsyncTask} from 'types/api/asyncTasks/asyncTask'

interface AsyncTaskContext {
  task: AsyncTask | null
  loadTasks: () => void
  confirm: () => void
  taskRunningProps: {disabled?: boolean; disabledReason?: string}
}

export const AsyncTaskContext = createContext<AsyncTaskContext>({
  task: null,
  loadTasks: () => {},
  confirm: () => {},
  taskRunningProps: {},
})

export const useAsyncTask = () => useContext(AsyncTaskContext)
